// extracted by css-extract-rspack-plugin
export default {"root":"root-OKB1Ve","main":"main-AXch1A","placeholder":"placeholder-pBYwAd","guidance":"guidance-BFqrEo text-sm"};